export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Otwórz spór"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anulować"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wysłać"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Moderator dołączy, aby pomóc. Proszę wybrać powód i załączyć dowody."])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wyślij do moderatora"])}
}